import React, { Component } from "react";
import { Table, Tag, Popconfirm, message, Empty, Space } from "antd";
import { PrinterOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import { ButtonItem } from "../../../../Components/Items";
import { fmtMXN, fechaTxt, PASOS } from "./aguinaldoUtils";

/**
 * Lista de procesos de aguinaldo de la empresa: borradores para continuar y aplicados para
 * consultar, imprimir o deshacer. Un clic en el renglón abre el asistente.
 */
class BandejaAguinaldo extends Component {
  state = { cargando: false, procesos: [] };

  componentDidMount() {
    this.cargar();
  }

  async cargar() {
    const { empresaId, headersToken } = this.props;
    this.setState({ cargando: true });
    try {
      const res = await axios.post("nomina/procesosAguinaldo", { empresaId }, { headers: headersToken });
      if (res.data.success === 2) this.setState({ procesos: res.data.data });
      else message.error(res.data.message || "No se pudieron cargar los procesos de aguinaldo");
    } catch {
      message.error("Error de conexión al cargar los procesos de aguinaldo");
    }
    this.setState({ cargando: false });
  }

  async eliminar(id) {
    const { empresaId, headersToken } = this.props;
    try {
      const res = await axios.post("nomina/eliminarProcesoAguinaldo", { empresaId, id }, { headers: headersToken });
      if (res.data.success === 2) {
        message.success("Borrador eliminado");
        this.cargar();
      } else {
        message.error(res.data.message || "No se pudo eliminar el borrador");
      }
    } catch {
      message.error("Error de conexión al eliminar el borrador");
    }
  }

  render() {
    const { onNuevo, onAbrir, onImprimir } = this.props;
    const { cargando, procesos } = this.state;

    const columnas = [
      { title: "Ejercicio", dataIndex: "ejercicio", width: 90, align: "center" },
      { title: "Corte", dataIndex: "fechaCorte", width: 100, align: "center", render: (f) => fechaTxt(f) },
      {
        title: "Tipo", dataIndex: "tipoAplicacion", width: 130,
        render: (t) => (t === "extraordinaria"
          ? <Tag color="purple">Extraordinaria</Tag>
          : <Tag color="blue">Ordinaria</Tag>),
      },
      { title: "Destino", dataIndex: "destino", ellipsis: true },
      { title: "Empleados", dataIndex: "empleados", width: 100, align: "center" },
      { title: "Total", dataIndex: "total", width: 130, align: "right", render: (n) => fmtMXN(n) },
      {
        title: "Estatus", dataIndex: "estatus", width: 170,
        render: (e, r) => (e === "aplicado"
          ? <Tag color="green">Aplicado</Tag>
          : (
            <span>
              <Tag color="gold">Borrador</Tag>
              <span className="aguinaldo-tenue">{PASOS[r.paso]?.titulo || ""}</span>
            </span>
          )),
      },
      {
        title: "Actualizado", dataIndex: "updatedAt", width: 140,
        render: (f) => (f ? moment(f).format("DD/MM/YYYY HH:mm") : ""),
      },
      {
        title: "", key: "acciones", width: 90, align: "center",
        render: (_, r) => (
          // stopPropagation: el clic en el renglón abre el asistente.
          <Space onClick={(e) => e.stopPropagation()}>
            <PrinterOutlined
              title="Imprimir / Excel"
              className="aguinaldo-accion"
              onClick={() => onImprimir(r._id)}
            />
            {r.estatus === "borrador" && (
              <Popconfirm
                title="¿Eliminar este borrador de aguinaldo?"
                okText="Eliminar"
                cancelText="Cancelar"
                onConfirm={() => this.eliminar(r._id)}
              >
                <DeleteOutlined title="Eliminar" className="aguinaldo-accion aguinaldo-accion-peligro" />
              </Popconfirm>
            )}
          </Space>
        ),
      },
    ];

    return (
      <div className="aguinaldo-tarjeta">
        <div className="aguinaldo-bandeja-cabecera">
          <div>
            <div className="aguinaldo-titulo">Procesos de aguinaldo</div>
            <div className="aguinaldo-tenue">
              Prepara el aguinaldo por pasos, guárdalo como borrador y aplícalo cuando esté listo.
            </div>
          </div>
          <ButtonItem type="primary" icon={<PlusOutlined />} onClick={onNuevo}>
            Nuevo proceso
          </ButtonItem>
        </div>
        <Table
          rowKey="_id"
          size="small"
          loading={cargando}
          columns={columnas}
          dataSource={procesos}
          pagination={{ pageSize: 15, hideOnSinglePage: true }}
          locale={{ emptyText: <Empty description="Todavía no hay procesos de aguinaldo" /> }}
          onRow={(r) => ({ onClick: () => onAbrir(r._id), style: { cursor: "pointer" } })}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(BandejaAguinaldo);
